export class AccountManagerDialogTrackingEvents {
  static contactButtonClick = '[Account Manager Dialog] contact button click';
  static fallbackButtonClick = '[Account Manager Dialog] fallback button click';
  static contactEmailClick = '[Account Manager Dialog] contact email click';
  static fallbackEmailClick = '[Account Manager Dialog] fallback email click';
}
